import { defineComponent as _defineComponent } from 'vue'
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import TitleCreditName from '@/components/details/TitleCreditName.vue';
import TitleCreditsPortrait from '@/components/details/TitleCreditsPortrait.vue';
import {
	GetAllCreditsDocument,
	GetAllCreditsQuery,
	GetAllCreditsQueryVariables,
} from '@/components/graphql/queries/GetAllCredits.query';
import { useQuery } from '@/helpers/composables/useApollo';
import { useI18n } from '@/helpers/composables/useI18n';

import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import BasicButton from '@/ui-components/BasicButton.vue';
import { storeToRefs } from 'pinia';
import { computed, ref, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCredits',
  props: {
    title: null,
    role: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, role: string };



const { country, language } = storeToRefs(useLanguageStore());
const { activeRoute } = storeToRefs(useRoutingStore());
const { t } = useI18n();

const propsCredits = computed(() => {
	if (props.title.__typename === 'Season') {
		return props.title.show?.content.credits ?? [];
	}

	return props.title.content.credits ?? [];
});
// this means that there can't be loaded more credits because it doesn't even fill up the `first: 20` limit
const hasLoadedMore = ref(propsCredits.value.length < 20);

const { result } = useQuery<GetAllCreditsQuery, GetAllCreditsQueryVariables>(
	GetAllCreditsDocument,
	() => ({
		fullPath: activeRoute.value.path,
		country: country.value,
		language: language.value,
	}),
	() => ({ enabled: hasLoadedMore.value, errorPolicy: 'all' })
);
const allCredits = computed(() => {
	const node = result.value?.urlV2.node;
	if (node?.__typename === 'Season') {
		return node.show?.content.credits ?? [];
	}
	if (node?.__typename === 'Movie' || node?.__typename === 'Show') {
		return node.content?.credits ?? [];
	}
	return [];
});

const credits = computed(() => {
	if (allCredits.value?.length > 0) {
		return allCredits.value;
	}
	return propsCredits.value;
});

const filteredCredits = computed(() => {
	if (!props.role) {
		return credits.value;
	}
	return credits.value.filter(credit => credit.role === props.role);
});

async function loadMore() {
	hasLoadedMore.value = true;
}

return { __sfc: true,props, country, language, activeRoute, t, propsCredits, hasLoadedMore, result, allCredits, credits, filteredCredits, loadMore, HiddenHorizontalScrollbar, TitleCreditName, TitleCreditsPortrait, BasicButton }
}

})